module.exports = __webpack_public_path__ + "img/0Q3A7086_L_Wood_MockedUp.59584ef0.jpg";